<template>
  <v-card>
    <v-card-title>
      Event Details
    </v-card-title>
    <v-card-text>
      <v-tiptap
        v-model="notes"
        :toolbar="argTypes"
        outlined
      />
    </v-card-text>
    <v-card-actions>
      <v-btn
        @click="submit"
      >
        Save event details
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import AdminClient from '@/api/AdminClient';
import EventsClient from '@/api/EventsClient';
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'AdminEventDetails',
  data() {
    return {
      argTypes: [
        'bold',
        'italic',
        'underline',
        'strike',
        'color',
        '|',
        'left',
        'center',
        'right',
        'justify',
        '|',
        'bulletList',
        'orderedList',
        '|',
        'link',
        'emoji',
        '|',
        'clear',
        'headings',
      ],
      eventId: this.$store.state.hackathonID,
      notes: this.$store.state.eventNotes,
    };
  },
  computed: {
    ...mapGetters({
      currentJwtToken: 'currentJwtToken',
    }),
  },
  methods: {
    ...mapActions({
      setEvent: 'setEvent',
    }),
    async submit() {
      const adminClient = new AdminClient(this.currentJwtToken);
      const eventsClient = new EventsClient(this.currentJwtToken);
      await adminClient.updateEventDetails(this.eventId, this.notes);
      const updatedEvent = await eventsClient.getEvent(this.eventId);
      this.setEvent(updatedEvent);
      this.$router.go();
    },
  },
};
</script>

<style lang="scss" scoped>
  ::v-deep  {
    .v-toolbar__content {
      background: #f5f5f5;
    }
  }
</style>
